import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { alertTypes, getAlertConfigs } from './AlertConfigs';

const D3Alert = ({ configType }) => {
  const alertConfig = getAlertConfigs(configType);
  return <Alert {...alertConfig}>{alertConfig.message}</Alert>;
};

D3Alert.defaultProps = {
  configType: 'default',
};

D3Alert.propTypes = {
  configType: PropTypes.oneOfType([
    PropTypes.oneOf(Object.keys(alertTypes)),
    PropTypes.shape({ apiErrorMessage: PropTypes.string }),
  ]),
};

export default D3Alert;
